import React, { useContext, useEffect, useState } from 'react'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import Container from '@material-ui/core/Container'
import Layout from '../Layout'
import DashboardHeader from '../DashboardHeader'
import AuthContext from '../../../Product/context/auth/authContext'
import AlertContext from '../../../Product/context/alert/alertContext'
import CustomDialog from '../../../Product/components/organisms/Dialog'
import { Button, IconButton } from '@material-ui/core'
import { useHistory } from 'react-router-dom'
import PrimaryButton from '../../../Product/components/atoms/PrimaryButton'
import { mapData } from '../../../Product/common/components'
import { dateFormatFront } from '../../../Product/common/components'
import { handleRedirectInternal } from '../../../Product/common/components'
import SEOTAG from '../../../utils/CommonFunctionality/SEO/AllpagesSEO'

const SavedSearch = (props) => {
    const authContext = useContext(AuthContext)
    const alertContext = useContext(AlertContext)

    const {
        isAuthenticated,
        recentSearch,
        responseStatus,
        clearResponse,
        recent_search,
        addRecentSearch,
        saveSearch,
        deleteSearch,
    } = authContext

    const [saveSearchs, setSaveSearchs] = useState(false)

    const history = useHistory()

    const [savedSearch, setSavedSearch] = useState({})

    const [search, setSearch] = useState({
        sh_limit: 10,
        page: 1,
    })

    // useEffect(() => addRecentSearch({ id: '', searchtext: '', date_added: '', location: '' }))[
    //     recentSearch
    // ]

    const [saveSearchParam, setSaveSearchsParam] = useState({
        searchbar: '',
    })

    const validationArray = Yup.object({
        searchbar: Yup.string().trim().required('Required'),
    })

    const formik = useFormik({
        initialValues: saveSearchParam,
        enableReinitialize: true,
        validationSchema: validationArray,
        onSubmit: async (values) => {
            saveSearch(values)
        },
    })

    useEffect(() => {
        if (responseStatus) {
            if (responseStatus.status === 'success') {
                if (responseStatus.from === 'deleteSearch') {
                    recentSearch(search)
                }
                if (responseStatus.from === 'saveSearch') {
                    formik.values.searchbar = ''
                    setSaveSearchs(false)
                    recentSearch(search)
                }
            }
        }
    }, [responseStatus])

    const deleteRecent = (id) => {
        deleteSearch({ id: id })
    }

    useEffect(() => {
        if (isAuthenticated) {
            recentSearch(search)
        }
    }, [isAuthenticated, search])

    const openSaveSearchs = () => {
        setSaveSearchs(!saveSearchs)
    }

    const saveSearchTerm = {
        formik: formik,
        data: [
            {
                label: 'Search Term' + '*',
                name: 'searchbar',
                type: 'text',
                placeholder: 'Enter the search value',
                class: 'col-12',
                autoFocus: true,
            },
        ],
    }

    const isVarifiedGfTheme = global.storeConfigration?.bodyClass?.value === 'greenField'

    return (
        <>
            <SEOTAG page="Saved Search" />
            <Layout props={props}>
                <div className="GFdashWrapperContainer">
                    <DashboardHeader />
                    <Container className="db-bids-wrapper mt-4 lq-db-table">
                        <div className="dashboard-wrapper savedSearches gfSvdSch">
                            <PrimaryButton btnSize="ssBtn" onClick={openSaveSearchs}>
                                Add a new saved search
                            </PrimaryButton>
                            <div className="table-responsive">
                                <table className="table stab savesearch table-hover mobile-table responisveTable">
                                    <thead>
                                        <tr>
                                            <th>{isVarifiedGfTheme ? 'ID' : 'ID'}</th>
                                            <th>{isVarifiedGfTheme ? 'Saved Search' : 'Title'}</th>
                                            <th>Date added</th>
                                            <th className={isVarifiedGfTheme ? 'text-center' : ''}>
                                                Action
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {recent_search.results.length ? (
                                            <>
                                                {recent_search.results.map((item, index) => {
                                                    return (
                                                        <tr key={index}>
                                                            <td data-label="id">{index + 1}</td>
                                                            <td data-label="Saved Search">
                                                                {isVarifiedGfTheme ? (
                                                                    <a
                                                                        href={`${
                                                                            window.location.origin
                                                                        }/${
                                                                            window.location.pathname.split(
                                                                                '/',
                                                                            )[1]
                                                                        }/search?q=${
                                                                            item.searchtext
                                                                        }&cat=&est=0&rat=&view=&sort=17&slimit=50`}
                                                                        className="navLinkColor"
                                                                    >
                                                                        {item.searchtext}
                                                                    </a>
                                                                ) : (
                                                                    item.searchtext
                                                                )}
                                                            </td>
                                                            <td data-label="Date added">
                                                                {dateFormatFront(item.date_added)}
                                                            </td>
                                                            <td data-label="Action">
                                                                <div className="d-flex justify-content-center ssActBtn">
                                                                    <Button
                                                                        onClick={() =>
                                                                            handleRedirectInternal(
                                                                                history,
                                                                                `search?q=${item.searchtext}&cat=&est=0&rat=&view=&sort=17&slimit=50`,
                                                                            )
                                                                        }
                                                                    >
                                                                        <span className="material-icons">
                                                                            open_in_new
                                                                        </span>
                                                                    </Button>
                                                                    <Button
                                                                        onClick={() =>
                                                                            deleteRecent(item.id)
                                                                        }
                                                                    >
                                                                        <span className="material-icons">
                                                                            delete
                                                                        </span>
                                                                    </Button>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    )
                                                })}
                                            </>
                                        ) : (
                                            <tr>
                                                <td colSpan="4">
                                                    <div className="np-pro-box">
                                                        {'No Saved Searches'}{' '}
                                                    </div>
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <CustomDialog
                            title={
                                <>
                                    Saved Searches
                                    <div style={{ float: 'right' }}>
                                        <IconButton className="popClrBtn" onClick={openSaveSearchs}>
                                            <span className="material-icons">clear</span>
                                        </IconButton>
                                    </div>
                                </>
                            }
                            open={saveSearchs}
                            function={openSaveSearchs}
                        >
                            <p>
                                You can now save this search into an organized folder in Profile
                                Saved Search letting you manage your results more easily.
                            </p>
                            <form className="login-ip-box" onSubmit={formik.handleSubmit}>
                                <div className="row">{mapData(saveSearchTerm)}</div>

                                <PrimaryButton label="Save Search" type="submit" />
                            </form>
                        </CustomDialog>
                    </Container>
                </div>
            </Layout>
        </>
    )
}

export default SavedSearch
